import {faPenToSquare, faTrash} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';

import * as styles from './actions-cell.scss';

export function renderCellActions(
    edit: () => void,
    remove: (() => void) | null,
    isEditDisabled?: boolean
): JSX.Element {
    return (
        <div className={styles.Actions}>
            <Button
                aria-label="edit"
                disabled={isEditDisabled}
                icon={<FontAwesomeIcon icon={faPenToSquare} />}
                onClick={edit}
                type="text"
            />

            {remove !== null ? (
                <Button aria-label="remove" icon={<FontAwesomeIcon icon={faTrash} />} onClick={remove} type="text" />
            ) : null}
        </div>
    );
}
